<template>
  <!-- Products Area -->
  <div class="products-area bg-white section-padding-md">

    <div class="container">
      <!-- Shop Page Products -->
      <div class="row justify-content-left shop-page-products products-wrapper">

        <!-- Single Product -->
        <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12" v-for="product in productList">
          <div class="product-item">

            <div class="product-item-images">
              <a :href="'/product/'+product.productCategoryName+'/'+product.productSn" :title="product.name"  class="product-item-image-inner">
                <img :src="product.pic" :alt="product.name" style="width: 100%;height: auto;">
              </a>
              <a :href="'/product/'+product.productCategoryName+'/'+product.productSn" :title="product.name" class="add-to-cart-button">
                <span>VIEW</span>
              </a>
            </div>

            <div class="product-item-content">
              <div class="product-item-content-left">
                <h5><a :href="'/product/'+product.productCategoryName+'/'+product.productSn" :title="product.name">{{product.name}}</a></h5>
              </div>
              <p>{{product.description}}</p>

            </div>

          </div>
        </div>
        <!--// Single Product -->
      </div>
    </div>

  </div>
</template>

<script>

  import request from '@/utils/request'
    export default {
        name: "index-product",
        data(){
          return {
            productList:[]
          }
        },
        methods:{
          loadPathProduct(){
            const  _this = this
            let reg = new RegExp("large-size","g");
            request({
              url: '/product/list-page',
              method: 'GET',
              params:{pageNum: 1, pageSize: 12,recommandStatus:1}
            }).then(res=>{
              if(res.data.code===200){
                _this.productList= res.data.data.list
                _this.productList.forEach((item,index)=>{
                  item.pic =item.pic.replace(reg,'thumbnail-size')
                })
              }
            })

          }
        },
        created(){
          this.loadPathProduct()
        }
    }
</script>

<style scoped>

</style>
